/**
 * Removes a leading street number (with optional letter suffix or hyphenated
 * range) from address_line1 and collapses whitespace. Used to derive the
 * "street name only" key for the city/street/state grouping queries.
 *
 * Per data-consumer-quickstart.md: address_line1 quality varies wildly across
 * sources, so this is best-effort. Callers should case-insensitive compare.
 */
export function stripStreetNumber(addressLine1) {
    return addressLine1
        .trim()
        .replace(/\s+/g, ' ')
        .replace(/^\d+(?:-\d+)?[A-Za-z]?\s+/, '');
}
//# sourceMappingURL=stripStreetNumber.js.map